module.exports = __webpack_public_path__ + "img/whiskey_sour.a558d811.jpg";